import { inject, Injectable } from '@angular/core';
import {
  ConsensusTemplateChange,
  ConsensusTemplateSseEventPayload,
} from '@api-types/sse/event-payloads/consensus-template.sse-event-payload';
import { SseEventType } from '@api-types/sse/sse.types';
import { SseEventHandler } from '@core/sse/sse-event-handler';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { selectCycleId } from 'demand-forecasting/store/router-state/router.selectors';
import { ToastrService } from 'ngx-toastr';
import { ConsensusTemplateStateService } from './consensus-template-state.service';

@Injectable()
export class ConsensusTemplateSseHandler implements SseEventHandler<
  typeof SseEventType.ConsensusTemplate
> {
  readonly eventType = SseEventType.ConsensusTemplate;

  private readonly stateService = inject(ConsensusTemplateStateService);
  private readonly toast = inject(ToastrService);
  private readonly translate = inject(TranslateService);
  private readonly store = inject(Store);

  private readonly cycleId = this.store.selectSignal(selectCycleId);

  handle(payload: ConsensusTemplateSseEventPayload): void {
    if (payload.cycleId !== this.cycleId()) {
      return;
    }

    if (payload.change === ConsensusTemplateChange.ColumnDeleted) {
      this.stateService.consensusColumns.reload();
      this.toast.info(
        this.translate.instant('CONSENSUS.COLUMN_DELETED_BY_OTHER_MESSAGE', {
          columnName: payload.columnName,
        }),
        this.translate.instant('CONSENSUS.COLUMN_DELETED_BY_OTHER_TITLE'),
      );
    }
  }
}
